<template>
  <h2 class="text-center mb-16 mb-lg-24">
    {{ $label(`common.howitworks.${variant}.title`) }}
  </h2>
  <p class="text-center mb-40">
    {{ $label(`common.howitworks.${variant}.subtitle`) }}
  </p>

  <div class="row">
    <HowItWorksBlock
      :title="$label(`common.howitworks.${variant}.firstBlock.title`)"
      :text="$label(`common.howitworks.${variant}.firstBlock.bodyTxt`)"
    >
      <div class="how-it-works__illustration"><RedeemIcon /></div>
    </HowItWorksBlock>

    <HowItWorksBlock
      :title="$label(`common.howitworks.${variant}.secondBlock.title`)"
      :text="$label(`common.howitworks.${variant}.secondBlock.bodyTxt`)"
    >
      <div class="how-it-works__illustration"><FingerPrintIcon /></div>
    </HowItWorksBlock>

    <HowItWorksBlock
      :title="$label(`common.howitworks.${variant}.thirdBlock.title`)"
      :text="$label(`common.howitworks.${variant}.thirdBlock.bodyTxt`)"
    >
      <div class="how-it-works__illustration">
        <BookFlipPageIcon stroke="#007754" />
      </div>
    </HowItWorksBlock>
  </div>
</template>

<script>
import RedeemIcon from '~/assets/icons/redeem.svg'
import FingerPrintIcon from '~/assets/icons/finger-print.svg'
import BookFlipPageIcon from '~/assets/icons/book-flip-page.svg'
import HowItWorksBlock from '~/components/howItWorks/HowItWorksBlock'

export default {
  components: {
    RedeemIcon,
    FingerPrintIcon,
    BookFlipPageIcon,
    HowItWorksBlock,
  },
  props: {
    variant: {
      required: true,
      validator(value) {
        return ['b2b', 'b2c'].includes(value)
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.how-it-works__illustration {
  background-color: $grey-01;
  padding: 6.2%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: auto;
  align-self: flex-start;

  svg {
    height: 24px;
    width: 24px;
  }

  &:first-of-type {
    mask: url('~/assets/icons/ellipse40.svg') no-repeat 50% 50%;
    mask-size: 100%;
  }
  &:nth-of-type(2) {
    mask: url('~/assets/icons/ellipse41.svg') no-repeat 50% 50%;
    mask-size: 100%;
  }
  &:nth-of-type(2) {
    mask: url('~/assets/icons/ellipse42.svg') no-repeat 50% 50%;
    mask-size: 100%;
  }
}

@include media-breakpoint-down(md) {
  .how-it-works__block {
    &:not(:last-child) {
      margin-bottom: 32px;
    }
  }
}

@include media-breakpoint-up(md) {
  .row {
    width: 100%;
  }

  .how-it-works__illustration {
    padding: 11.1%;
    align-self: center;

    svg {
      height: 48px;
      width: 48px;
    }
  }
}

.col {
  flex: 1;
}
</style>
